import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentCompany } from "../../store/slices/authSlice";
import {
  useGetMyTeamMembersQuery,
  useGetCompanySubmissionsQuery,
  useGetCompanyDiagnosticSubmissionsQuery,
  useGetCompanyDevelopmentPlansQuery,
} from "../../services/api";
import "./Analytics.css";

// Icons (keeping existing SVGs)
const TeamIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_team)">
      <path d="M3.33398 4.66667C3.33398 5.37391 3.61494 6.05219 4.11503 6.55229C4.61513 7.05238 5.29341 7.33333 6.00065 7.33333C6.7079 7.33333 7.38617 7.05238 7.88627 6.55229C8.38637 6.05219 8.66732 5.37391 8.66732 4.66667C8.66732 3.95942 8.38637 3.28115 7.88627 2.78105C7.38617 2.28095 6.7079 2 6.00065 2C5.29341 2 4.61513 2.28095 4.11503 2.78105C3.61494 3.28115 3.33398 3.95942 3.33398 4.66667Z" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 14V12.6667C2 11.9594 2.28095 11.2811 2.78105 10.781C3.28115 10.281 3.95942 10 4.66667 10H7.33333C8.04058 10 8.71885 10.281 9.21895 10.781C9.71905 11.2811 10 11.9594 10 12.6667V14" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.666 2.08667C11.2396 2.23354 11.748 2.56714 12.1111 3.03488C12.4742 3.50262 12.6712 4.07789 12.6712 4.67C12.6712 5.26212 12.4742 5.83739 12.1111 6.30513C11.748 6.77287 11.2396 7.10647 10.666 7.25334" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14 14.0001V12.6668C13.9966 12.0782 13.7986 11.5073 13.4368 11.043C13.0751 10.5788 12.5699 10.2472 12 10.1001" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_team">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_check)">
      <path d="M3.33398 8.00008L6.66732 11.3334L13.334 4.66675" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_check">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const GaugeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_gauge)">
      <path d="M5.70643 2.45996C4.97849 2.76129 4.31701 3.20302 3.75977 3.75996" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.46 5.70679C2.1577 6.43365 2.0014 7.2129 2 8.00012" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.46094 10.2932C2.76226 11.0212 3.204 11.6826 3.76094 12.2399" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.70703 13.54C6.4339 13.8423 7.21315 13.9986 8.00036 14" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.293 13.54C11.0209 13.2387 11.6824 12.7969 12.2396 12.24" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.5391 10.2933C13.8414 9.56647 13.9977 8.78722 13.9991 8" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13.5402 5.70668C13.2389 4.97873 12.7972 4.31726 12.2402 3.76001" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.2933 2.46C9.56647 2.1577 8.78722 2.0014 8 2" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_gauge">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_chart)">
      <path d="M2 11.3334L6 7.33341L8.66667 10.0001L14 4.66675" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.33398 4.66675H14.0007V9.33341" stroke="#2A987A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_chart">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default function Analytics() {
  const navigate = useNavigate();
  const company = useSelector(selectCurrentCompany);
  const companyId = company?._id || company?.id;

  // Fetch real data
  const { data: teamData, isLoading: teamLoading } = useGetMyTeamMembersQuery(
    { companyId },
    { skip: !companyId }
  );
  const { data: valueSubmissionsData, isLoading: valuesLoading } = useGetCompanySubmissionsQuery(
    { companyId },
    { skip: !companyId }
  );
  const { data: diagnosticSubmissionsData, isLoading: diagnosticsLoading } = useGetCompanyDiagnosticSubmissionsQuery(
    { companyId },
    { skip: !companyId }
  );
  const { data: devPlansData, isLoading: plansLoading } = useGetCompanyDevelopmentPlansQuery(
    { companyId },
    { skip: !companyId }
  );

  const isLoading = teamLoading || valuesLoading || diagnosticsLoading || plansLoading;

  // Calculate stats from real data
  const members = teamData?.members || [];
  const teamCount = members.length;

  const valueSubmissions = valueSubmissionsData?.submissions || valueSubmissionsData || [];
  const valuesSubmitted = Array.isArray(valueSubmissions)
    ? valueSubmissions.filter(s => s.status === 'submitted').length
    : 0;
  const valuesTotal = Array.isArray(valueSubmissions) ? valueSubmissions.length : 0;
  const valuesPercent = valuesTotal > 0 ? Math.round((valuesSubmitted / valuesTotal) * 100) : 0;

  const diagnosticSubmissions = diagnosticSubmissionsData?.submissions || diagnosticSubmissionsData || [];
  const diagnosticsSubmitted = Array.isArray(diagnosticSubmissions)
    ? diagnosticSubmissions.filter(s => s.status === 'submitted').length
    : 0;
  const diagnosticsTotal = Array.isArray(diagnosticSubmissions) ? diagnosticSubmissions.length : 0;
  const diagnosticsPercent = diagnosticsTotal > 0 ? Math.round((diagnosticsSubmitted / diagnosticsTotal) * 100) : 0;

  const devPlans = devPlansData?.plans || devPlansData || [];
  const devPlanCount = Array.isArray(devPlans) ? devPlans.length : 0;

  // Build cards with real data
  const cards = [
    {
      id: 1,
      title: "Team Size",
      value: String(teamCount).padStart(2, '0'),
      icon: <TeamIcon />,
    },
    {
      id: 2,
      title: "Values Done",
      value: `${valuesPercent}%`,
      icon: <CheckIcon />,
    },
    {
      id: 3,
      title: "Diagnostics Done",
      value: `${diagnosticsPercent}%`,
      icon: <GaugeIcon />,
    },
    {
      id: 4,
      title: "Dev Plans",
      value: String(devPlanCount).padStart(2, '0'),
      icon: <ChartIcon />,
    },
  ];

  // Build team progress data for table
  const getSubmissionStatus = (submissions, memberId) => {
    if (!Array.isArray(submissions)) return 'none';
    const memberSubmission = submissions.find(s =>
      s.employee?._id === memberId || s.employee === memberId
    );
    if (!memberSubmission) return 'none';
    return memberSubmission.status === 'submitted' ? 'done' : 'pending';
  };

  const getDevPlanStatus = (plans, memberId) => {
    if (!Array.isArray(plans)) return 'none';
    const memberPlan = plans.find(p =>
      p.user?._id === memberId || p.user === memberId
    );
    if (!memberPlan) return 'none';
    return memberPlan.isActive ? 'active' : 'inactive';
  };

  const teamProgress = members.map(member => ({
    id: member._id,
    name: `${member.firstName} ${member.lastName}`,
    values: getSubmissionStatus(valueSubmissions, member._id),
    diagnostics: getSubmissionStatus(diagnosticSubmissions, member._id),
    devPlan: getDevPlanStatus(devPlans, member._id),
  }));

  const getStatusBadge = (status, type) => {
    switch (status) {
      case 'done':
      case 'active':
        return <span className="status-badge status-done">✓ Done</span>;
      case 'pending':
        return <span className="status-badge status-pending">Pending</span>;
      case 'inactive':
        return <span className="status-badge status-inactive">Inactive</span>;
      default:
        return <span className="status-badge status-none">—</span>;
    }
  };

  return (
    <div className="analytics-container">
      <button className="welcome" onClick={() => navigate('/dashboard')}>
        ← Back Home
      </button>
      <div className="page-header">
        <h1 className="username">Analytics</h1>
      </div>

      {/* Top Stats Cards */}
      <div className="analytics-cards">
        {cards.map((c) => (
          <div key={c.id} className="analytics-card">
            <div className="analytics-head">
              <span className="analytics-icon">{c.icon}</span>
              <span className="analytics-title">{c.title}</span>
            </div>
            <div className="analytics-card-value">
              {isLoading ? "..." : c.value}
            </div>
          </div>
        ))}
      </div>

      {/* Team Progress Table */}
      <div className="analytics-card full">
        <div className="analytics-card-head">Team Progress</div>

        <div className="analytics-table-wrap">
          {isLoading ? (
            <div className="analytics-loading">Loading team data...</div>
          ) : teamProgress.length === 0 ? (
            <div className="analytics-empty">No team members found.</div>
          ) : (
            <table className="analytics-table">
              <thead>
                <tr className="analytics-dev-first">
                  <th>Team Member</th>
                  <th>Values</th>
                  <th>Diagnostics</th>
                  <th>Dev Plan</th>
                </tr>
              </thead>
              <tbody>
                {teamProgress.map((member) => (
                  <tr key={member.id}>
                    <td>{member.name}</td>
                    <td>{getStatusBadge(member.values)}</td>
                    <td>{getStatusBadge(member.diagnostics)}</td>
                    <td>{getStatusBadge(member.devPlan)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
